import React from 'react';

const DisplayWindow =({children} : any) =>{
    return(
        <div className="display-container">
            <div>{children}</div>
        </div>
    )
}

export default React.memo(DisplayWindow);
